module.exports = __webpack_public_path__ + "static/media/bigblue.b611a17e.jpg";